import { Component, Input, ChangeDetectionStrategy, Inject, NgModuleRef, TemplateRef, OnInit } from '@angular/core';
import { IModalsService, IMODALS_SERVICE } from '@platform500services/p500-ui-kit';
import { Observable } from 'rxjs';
import { IUnsecuredService, IUnsecuredStatus } from '../../../../services/unsecured/unsecured-service.interface';
import { Auth2FAUnsecuredModal } from '../../../../modals/2fa-unsecured/2fa-unsecured.modal';
import { AuthServiceInterface } from '../../../../services/auth/auth-service.interface';
import { DestroySubscribers } from '../../../../decorators/destroy-subscribers.decorator';
import { Account2FAModal } from '../../../../modals/2fa/2fa-modal.component';

@Component({
  selector: 'gtd-ui-field-default-protected',
  templateUrl: './protected.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@DestroySubscribers()
export class ProtectedFieldComponent implements OnInit {
  @Input() data: any;
  @Input() customClass = '';
  @Input() fixedLength = 6;
  @Input() copyToClipboard: boolean;
  @Input() tmpl: TemplateRef<any>;
  @Input() whitespaceLength: number;
  public unsecuredStatus$: Observable<IUnsecuredStatus>;
  private otp: boolean;

  private subscribers: any = {};

  constructor(
    @Inject('IUnsecuredService') public unsecuredService: IUnsecuredService,
    @Inject(IMODALS_SERVICE) private modalsService: IModalsService,
    @Inject('AuthServiceInterface') public authService: AuthServiceInterface,
    private moduleRef: NgModuleRef<any>
  ) {
    this.unsecuredStatus$ = this.unsecuredService.getUnsecuredStatus();
  }

  ngOnInit() {
    this.subscribers.otp = this.authService.otp$.subscribe((otp) => (this.otp = otp));
  }

  getDotsString(): string {
    return ' • '.repeat(this.fixedLength || this.data?.length || 0).trim();
  }

  enableUnsecuredMode(): void {
    if (this.unsecuredService.isUnsecuredValue) {
      return;
    }

    if (this.otp) {
      this.modalsService.open(Auth2FAUnsecuredModal, {}, this.moduleRef);
    } else {
      this.modalsService.open(
        Account2FAModal,
        {
          callback: () => {
            this.enableUnsecuredMode();
          },
          onlyEnable: true,
        },
        this.moduleRef
      );
    }
  }
}
